import React, { useState, useEffect } from "react";
import { useStyles } from "./ChoixDates.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Alert } from "@material-ui/lab";
import { Button, Grid, Typography, Card, CardContent } from "@material-ui/core";
import rest from "../../../rest";
import DomAcordeon from "./DomAccordion";

import AffichageSelctDate, { sorteGroupeActivity } from "./AfficheDateSelected";

import useStylesThemes from "../../css/globalTheme";

const validateTranche = (
  obj,
  nbJourMin,
  nbTrancheByJour,
  minActivite,
  maxActivite,
  regleTranche
) => {
  // Vérification du nombre d'activités
  const nbActivites = Object.keys(obj).length;
  if (nbActivites < minActivite || nbActivites > maxActivite) {
    return { test: 1 };
  }
  // Vérification pour chaque activité
  for (const [activite, jours] of Object.entries(obj)) {
    const nbJoursConformes = Object.values(jours).filter(
      (tranches) => tranches >= nbTrancheByJour
    ).length;
    const nbJoursTotal = Object.keys(jours).length;
    // si pas asser de jours
    if (nbJoursTotal < nbJourMin) return { test: 2, activite: activite };

    if (regleTranche === 0) {
      // Tous les jours doivent avoir au moins nbTrancheByJour tranches
      if (nbJoursConformes < nbJoursTotal) {
        return { test: 3, activite: activite };
      }
    } else {
      // Au moins nbJourMin jours doivent avoir nbTrancheByJour tranches
      if (nbJoursConformes < nbJourMin) {
        return { test: 4, activite: activite };
      }
    }
  }

  return { test: 0 };
};

const ChoixDates = (props) => {
  const [showWarning, setShowWarning] = useState(false);
  const classes = useStyles();
  const manifInfo = props.manifInfo;
  const selectedValues = props.selectedValues;
  const setSelectedValues = props.setSelectedValues;
  const [firstActivity, setFirstActivity] = useState([]);
  const [activity, setActivity] = useState([]);
  const [dayActivity, setDayActivity] = useState([]);
  const [trancheHoraire, setTrancheHoraire] = useState([]);
  const [groupedActivities, setGroupedActivities] = useState({});
  const [regleTranche, setRegleTranche] = useState({});

  const [nbJourMin, setNbJourMin] = useState(0);
  const [nbTrancheByJour, setNbTrancheByJour] = useState(0);
  const [minActivite, setMinActivite] = useState(0);
  const [maxActivite, setMaxActivite] = useState(0);

  const [errorMessages, setErrorMessages] = useState([]);

  const styleTheme = useStylesThemes()();

  const getDay = (date) => {
    let arrayDay = [];
    date.forEach((item) => {
      if (
        arrayDay.find(
          (day) => day.parentId === item.parentId && item.longDate === day.Nom
        ) === undefined
      ) {
        arrayDay.push({
          parentId: item.parentId,
          Nom: item.longDate,
          ID: item.ID,
          DateActivite: item.DateActivite,
          short: item.shortDate,
        });
      }
    });
    setDayActivity(arrayDay);
  };

  // function pluralize(word, count) {
  //   return count === 1 ? word : `${word}s`;
  // }

  useEffect(() => {
    setGroupedActivities(sorteGroupeActivity(selectedValues));
  }, [selectedValues]);

  const sortActiviterByName = (users) => {
    return users.sort((a, b) => {
      if (a.Nom < b.Nom) return -1;
      if (a.Nom > b.Nom) return 1;
      return 0;
    });
  };

  useEffect(() => {
    let isMounted = true;

    rest
      .get("/activites/actionsv2/firstLevelActivity.json")
      .then((response) => {
        if (isMounted) {
          const sort = sortActiviterByName(response.data);
          setFirstActivity(sort);
        }
      });

    rest
      .get("/activites/actionsv2/activitesDisponibles.json")
      .then((response) => {
        if (isMounted) {
          const sort = sortActiviterByName(response.data);
          setActivity(sort);
        }
      });

    rest.get("/activites/actionsv2/getDateOfActivity.json").then((response) => {
      if (isMounted) {
        setTrancheHoraire(response.data);
        getDay(response.data);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  // set les règles
  useEffect(() => {
    setNbJourMin(
      !manifInfo.NbMinWishlist || manifInfo.NbMinWishlist === ""
        ? 0
        : manifInfo.NbMinWishlist
    );
    setNbTrancheByJour(manifInfo.NbTrancheMinWishlist);
    setMinActivite(manifInfo.NbActMinWishlist);
    setMaxActivite(manifInfo.NbActMaxWishlist);
    // 0 = Tous les jours (par défaut) / 1 = Le nombre de jour(s) indiqué uniquement
    setRegleTranche(manifInfo.InscriptionWishlistTypeChoix);
  }, [manifInfo]);

  // Passe a l'étape suivante si les règles sont respectées
  const showNext = () => {
    const nbTranchesByActAndDay = {};

    // Parcourir groupedActivities pour compter les tranches et les jours par activité
    Object.keys(groupedActivities).forEach((activity) => {
      const days = Object.keys(groupedActivities[activity]);

      days.forEach((day) => {
        if (!nbTranchesByActAndDay[activity]) {
          nbTranchesByActAndDay[activity] = {};
        }
        if (!nbTranchesByActAndDay[activity][day]) {
          nbTranchesByActAndDay[activity][day] = 0;
        }
        nbTranchesByActAndDay[activity][day] +=
          groupedActivities[activity][day].length;
      });
    });

    const validHoraire = validateTranche(
      nbTranchesByActAndDay,
      nbJourMin,
      nbTrancheByJour,
      minActivite,
      maxActivite,
      regleTranche
    );

    // 0 = conform 1 = nombre activité non conform 2 = nb de jour par activité non conform 3-4 nb tranche par jour et activité non conforme
    if (validHoraire.test > 0) {
      setShowWarning(true);
      setErrorMessages("");
    } else {
      setShowWarning(false);
      setErrorMessages([]);
      props.setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  return (
    <React.Fragment>
      <main className={classes.content}>
        {manifInfo.TexteInscriptionWishlistChoixActivites !== "" && (
          <Grid container className={classes.marginGrid}>
            <Grid item xs={12} className={classes.alertContainer}>
              <Alert
                severity={showWarning ? "error" : "warning"}
                className={classes.alertCustom}
              >
                <div
                  className={classes.alertContent}
                  style={{ marginLeft: 8, marginBottom: 8 }}
                  dangerouslySetInnerHTML={{
                    __html: manifInfo.TexteInscriptionWishlistChoixActivites,
                  }}
                />
                {showWarning && errorMessages.length > 0 && (
                  <ul>
                    {errorMessages.map((msg, idx) => (
                      <li key={idx}>{msg}</li>
                    ))}
                  </ul>
                )}
              </Alert>
            </Grid>
          </Grid>
        )}

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            {firstActivity.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  <DomAcordeon
                    onChange={(val, selectAll = false, isChecked) => {
                      const tmp = [...selectedValues];

                      if (selectAll && !isChecked) {
                        // suprimer toute la liste
                        const idsToRemove = val.map((item) => item.ID);
                        const filteredTmp = tmp.filter(
                          (item) => !idsToRemove.includes(item.ID)
                        );
                        setSelectedValues([...filteredTmp]);
                        return;
                      }

                      val.forEach((v) => {
                        const alreadySelectedIndex = selectedValues.findIndex(
                          (value) => value.ID === v.ID
                        );
                        if (!selectAll) {
                          if (alreadySelectedIndex !== -1) {
                            // existe
                            tmp.splice(alreadySelectedIndex, 1); // Retire l'élément déjà sélectionné
                          } else {
                            tmp.push(v);
                          }
                        } else {
                          if (isChecked)
                            if (alreadySelectedIndex === -1) tmp.push(v);
                        }
                      });
                      setSelectedValues([...tmp]);
                    }}
                    activity={activity}
                    dayActivity={dayActivity}
                    trancheHoraire={trancheHoraire}
                    item={item}
                    level="1"
                    style={{ backgroundColor: "#b7b7b7" }}
                    selectedValues={selectedValues}
                  />
                </React.Fragment>
              );
            })}
          </Grid>

          <Grid item xs={12} md={6}>
            <Card elevation={3} style={{ borderRadius: 8 }}>
              <CardContent>
                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Grid item>
                    <Typography
                      variant="h5"
                      style={{
                        fontWeight: "bold",
                        color: "black",
                        fontSize: 20,
                      }}
                    >
                      Dates sélectionnées
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Button
                      size="medium"
                      variant="contained"
                      color="primary"
                      className={styleTheme.validateButton}
                      onClick={showNext}
                    >
                      Valider
                    </Button>
                  </Grid>
                </Grid>
                {groupedActivities.length === 0 ? (
                  <Typography variant="body1" style={{ marginTop: 20 }}>
                    Aucune date sélectionnée
                  </Typography>
                ) : (
                  <AffichageSelctDate
                    dataFrom={"selectionDates"}
                    groupedActivities={groupedActivities}
                  />
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </main>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    activites: state.activites,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ChoixDates);
